import { userConstants } from "../../constant";

const initialState = {
  homepageAd: null,
  bestSellers: [],
  recommendedProducts: [],
  isPersonalized: false,
  activeCampaigns: [],
  successStories: [],
  featuredBundles: [],
};

export function landingPage(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_HOMEPAGE_AD:
      return { ...state, homepageAd: action.payload };
    case userConstants.GET_BEST_SELLERS:
      return { ...state, bestSellers: action.payload };
    case userConstants.GET_RECOMMENDED_PRODUCTS:
      return {
        ...state,
        recommendedProducts: action.payload.products,
        isPersonalized: action.payload.personalized,
      };
    case userConstants.GET_ACTIVE_CAMPAIGNS:
      return { ...state, activeCampaigns: action.payload };
    case userConstants.GET_SUCCESS_STORIES:
      return { ...state, successStories: action.payload };
    case userConstants.GET_FEATURED_BUNDLES:
      return { ...state, featuredBundles: action.payload };
    default:
      return state;
  }
}
